import { mdiBookAccountOutline } from '@mdi/js'

export default {
  title: 'E-Raport',
  to: 'eraport-teacher',
  icon: mdiBookAccountOutline,
  action: 'read',
  resource: 'EraportTeacher',
}
